import { render, staticRenderFns } from "./navMenuSetting.vue?vue&type=template&id=8c4ee1a6&"
import script from "./navMenuSetting.vue?vue&type=script&lang=js&"
export * from "./navMenuSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/navMenuSetting/navMenuSetting.vue"
export default component.exports